import { Drawer, LoadingButton } from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
import { BopisOutOfStockDrawerContent } from './BopisOutOfStockDrawerContent';
import { EditDeliveryAddressDrawerContent } from '../EditDeliveryAddress/EditDeliveryAddressDrawerContent';
import { useOrderContext } from '../../../hooks/useContexts';
import { EditPickupLocationDrawer } from '../EditPickupLocation/EditPickupLocationDrawer';
import { TrackBopisOosrAnalytics } from '../../../utils/bopis/bopis-oosr-analytics';
export var BopisOutOfStockButton = function (_a) {
    var open = _a.open, setOpen = _a.setOpen;
    var _b = useOrderContext(), currentDrawer = _b.currentDrawer, setShowDrawerError = _b.setShowDrawerError;
    var _c = useState(false), isOuterClick = _c[0], setIsOuterClick = _c[1];
    return (React.createElement("div", { className: "card-fix" },
        React.createElement(LoadingButton, { variant: "secondary", onClick: function () {
                TrackBopisOosrAnalytics('out of stock review your options', 'overlay');
                setOpen(true);
            } }, "Review Your Options"),
        React.createElement(Drawer, { open: open, onClose: function () {
                // Outer click will trigger closeDrawer on rendered drawer content
                setIsOuterClick(true);
            } },
            !currentDrawer && open && (
            // Drawer content: Recovery options buttons
            React.createElement(BopisOutOfStockDrawerContent, { setOpen: setOpen, isOuterClick: isOuterClick, setIsOuterClick: setIsOuterClick })),
            currentDrawer === 'STH_DELIVERY_OPTION' && open && (
            // Drawer content: Edit delivery address
            React.createElement(EditDeliveryAddressDrawerContent, { setOpen: setOpen, setShowDrawerError: setShowDrawerError, isBopisOutOfStock: true, isOuterClick: isOuterClick, setIsOuterClick: setIsOuterClick })),
            currentDrawer === 'STORE_PICKUP_OPTION' && open && (
            // Drawer content: Pickup location
            React.createElement(EditPickupLocationDrawer, { setOpen: setOpen, setShowDrawerError: setShowDrawerError, isBopisOutOfStock: true, isOuterClick: isOuterClick, setIsOuterClick: setIsOuterClick })))));
};
